import BigNumber from 'bignumber.js'
import { useCallback, useEffect, useMemo, useState } from "react"
import { use721Contract } from "./useContract";
import { useActiveWeb3React } from "./web3";


export const useWhitelist = () => {
    const contract = use721Contract();
    const { account } = useActiveWeb3React();

    const [owner, setowner] = useState("")

    useEffect(() => {
        const getowner = async () => setowner(await contract.owner())
        getowner()
    }, [account, contract])

    const whitelist = useCallback(async (abc) => {
        var mynewarray = abc.split(',')
        if (owner === account) {
            const tx = await contract.whitelistUsers(mynewarray, { from: account, });
            const receipt = await tx.wait();
            console.log("receipt", receipt);
        } else {
            alert("You are not owner")
        }
    }, [account, contract, owner])

    const isowner = useMemo(() => owner === account, [account, owner])

    return { whitelist ,isowner}
}